module.exports = __webpack_public_path__ + "img/Kraftfahrzeug.0eccfbe2.svg";